import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const SecurityWrapper = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const isCheckingRef = useRef(false);

  const checkForXSS = (pathname) => {
    const dangerousPatterns = [
      '<', '>', '"', "'", '`',
      'javascript:', 'data:', 'vbscript:',
      'onclick', 'onerror', 'onload',
      'alert', 'confirm', 'prompt',
      'document', 'window', 'eval',
      'script', 'style', 'iframe',
      '%3C', '%3E', '%22', '%27',
      '\\x3c', '\\x3e', '\\x22', '\\x27'
    ];

    let pathToCheck = pathname;
    try {
      pathToCheck = decodeURIComponent(pathname);
    } catch (e) {
      return true;
    }

    const containsDangerousPatterns = dangerousPatterns.some(pattern =>
      pathToCheck.toLowerCase().includes(pattern.toLowerCase())
    );

    if (containsDangerousPatterns) {
      return true;
    }

    return false;
  };

  useEffect(() => {
    if (!isCheckingRef.current && checkForXSS(location.pathname)) {
      isCheckingRef.current = true;
      navigate('/', { replace: true });
      setTimeout(() => {
        isCheckingRef.current = false;
      }, 100);
    }
  }, [location.pathname, navigate]);

  useEffect(() => {
    const originalPushState = window.history.pushState;
    window.history.pushState = function(state, title, url) {
      const urlPath = typeof url === 'string' ? url : String(url);
      
      if (checkForXSS(urlPath)) {
        navigate('/', { replace: true });
        return;
      }
      
      originalPushState.apply(window.history, arguments);
      
      window.dispatchEvent(new PopStateEvent('popstate', { state }));
    };

    const originalReplaceState = window.history.replaceState;
    window.history.replaceState = function(state, title, url) {
      const urlPath = typeof url === 'string' ? url : String(url);
      
      if (checkForXSS(urlPath)) {
        navigate('/', { replace: true });
        return;
      }
      
      originalReplaceState.apply(window.history, arguments);
      
      window.dispatchEvent(new PopStateEvent('popstate', { state }));
    };

    const handlePopState = () => {
      if (checkForXSS(window.location.pathname)) {
        navigate('/', { replace: true });
      }
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.history.pushState = originalPushState;
      window.history.replaceState = originalReplaceState;
      window.removeEventListener('popstate', handlePopState);
    };
  }, [navigate]);

  return <>{children}</>;
};

export default SecurityWrapper;